import Constants from '@constants'

export default {
  install: (app) => {
    app.config.globalProperties.$constants = Constants

    app.provide('constants', Constants)
  }
}